import React from 'react';
import { Container, Card, Button } from 'react-bootstrap';
import { Link } from "react-router-dom";
import { useSelector } from 'react-redux';

const InformationScreen = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const sections = [
    {
      title: "Information",
      content:
        "The ShotARC web application is a research project at Dundalk Institute of Technology (DkIT) to improve prediction models for shot success in Gaelic Football. This application is available free of charge. DkIT will not be responsible for any loss of information associated with this application.",
    },
    {
      title: "How to Use ShotArc",
      content:
        `To use ShotArc, follow these steps:
  1. Begin by setting up your players in the squads page. You do not need to setup opposition players unless you want to analyse opposition shots by player.
  2. Create a new game and then, while having the video for the game open in a separate window, enter the details of each shot including the location, type, and outcome.
  3. You are then in a position to analyse the performance of the team by game, player and over the season.`,
    },
    {
      title: "Development Team",
      content:
        "The ShotArc application was developed by Dr Kevin McDaid along with Filipe Carvalho, Jamie Lawlor, Dr Jack McDonnell, Christopher Healy, Yu Kang Ong, Michael Rogers, Shane Smyth, Haroldas Tamosauskas and Bianca Valicec.",
    },
    {
      title: "Participation",
      content:
        "If you wish to no longer participate in the project please email kevin.mcdaid@dkit.ie.",
    },
    {
      title: "Agreement",
      content:
        "All data collected through this application will be used, on an anonymous basis, to research and improve existing statistical prediction models. The data will only be used for this purpose and no teams or individuals will be identified.",
    },
  ];

  return (
    <Container className="pt-4 app-section-page">
      <title>Information | ShotArc</title>
      <h2 className="app-page-title info-page-title">Information</h2>

      <Card className="border-warning mb-4 info-shell">
        <Card.Header className="bg-warning text-dark">
          <strong>ShotArc Information</strong>
        </Card.Header>
        <Card.Body className="bg-dark text-white">
          {sections.map((section, idx) => (
            <section
              key={section.title}
              className={`info-section${idx < sections.length - 1 ? " info-section-divider" : ""}`}
            >
              <h5 className="info-section-title">{section.title}</h5>
              <p className="mb-0 info-section-text" style={{ whiteSpace: "pre-line" }}>
                {section.content}
              </p>
              {section.title === "How to Use ShotArc" && (
                <a
                  href="https://youtu.be/kfNYQScltbA"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Watch the introductory video
                </a>
              )}
            </section>
          ))}
        </Card.Body>
      </Card>

      {!userInfo && (
        <Button as={Link} to="/RegisterScreen" variant="warning" className="text-dark fw-semibold px-3">
          Back to Register
        </Button>
      )}
    </Container>

  );
};

export default InformationScreen;
